import React from 'react';
const Loading = () => {
  return (
    <div className='loading-icon'>
      <img src="https://thebowlcut.com/cdn/shop/t/41/assets/loading.gif?v=157493769327766696621701744369" alt='loading'/>
    </div>
  );
}

export default Loading;
